<template>
  <div
    class="
      d-flex
      justify-space-between
      align-center
      flex-sm-column flex-lg-row
      py-8
    "
  >
    <div class="badge-container">
      <!-- <img src="@/assets/badge-user-icon.svg" class="user-image" :height="size" /> -->

      <v-sheet
        :height="size"
        :width="size"
        class="user-image circle d-flex justify-center align-center"
        color="#FAE0D4"
      >
        <img
          src="@/assets/user.png"
          :height="size * 0.45"
          :width="size * 0.45"
          alt=""
          contain
        />
      </v-sheet>

      <v-sheet
        flat
        class="badge-image circle d-flex justify-center align-center"
        :height="size * 0.325"
        :width="size * 0.325"
      >
        <v-sheet
          :class="[
            'circle d-flex justify-center align-center',
            { 'dashed-border': logo == '' },
          ]"
          :outlined="logo != ''"
          :height="size * 0.29"
          :width="size * 0.29"
        >
          <img
            v-if="logo != ''"
            :src="logo"
            class="circle"
            :height="size * 0.29"
            :width="size * 0.29"
          />
          <div v-else class="grey--text text-center logo-text">
            Add your logo
          </div>
        </v-sheet>
      </v-sheet>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logo: { type: String, default: "" },
    size: { type: Number, default: 140 },
  },
};
</script>

<style>
.badge-container {
  position: relative;
}
.badge-container .user-image {
  display: block;
}
.badge-container .badge-image {
  position: absolute;
  bottom: 0;
  right: 0;
}
.dashed-border {
  border: 1px dashed #c5cdda !important;
}
.logo-text {
  font-size: 8px;
  line-height: 10px;
}
</style>
